import {
    PGTOWEB_LIST, PGTOWEB_ISLOADING
} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    pgtoweblist: [],
    isloading: true,
}

export default (state = INITIAL_STATE, action) => {


    switch (action.type) {

        case PGTOWEB_LIST:
            return { ...state, pgtoweblist: action.payload }
        case PGTOWEB_ISLOADING:
            return { ...state, isloading: action.payload }

        default:
            return state;
    }
}